import * as constants from './constants'

// ------------------------------------
// Actions
// ------------------------------------
export const addErrors = violations => ({
  payload: { violations },
  type: constants.ADD_ERRORS,
})
export const advanceToAccount = () => ({
  type: constants.ADVANCE_TO_ACCOUNT,
})
export const advanceToDetail = () => ({
  type: constants.ADVANCE_TO_DETAIL,
})
export const advanceToOffer = () => ({
  type: constants.ADVANCE_TO_OFFER,
})
export const advanceToSummary = () => ({
  type: constants.ADVANCE_TO_SUMMARY,
})
export const agreeTerms = agree => ({
  payload: { agree },
  type: constants.AGREE_TERMS,
})
export const applyCoupon = () => ({
  type: constants.APPLY_COUPON,
})
export const authenticate = () => ({
  type: constants.AUTHENTICATE,
})
export const begin = location => ({
  payload: {
    location,
  },
  type: constants.BEGIN,
})
export const beginPartner = partner => ({
  payload: {
    partner,
  },
  type: constants.BEGIN_PARTNER,
})
export const beginValidation = () => ({
  type: constants.BEGIN_VALIDATION,
})
export const beginWork = () => ({
  type: constants.BEGIN_WORK,
})
export const checkedEmail = (registered = false) => ({
  payload: { registered },
  type: constants.CHECKED_EMAIL,
})
export const checkingEmail = () => ({
  type: constants.CHECKING_EMAIL,
})
export const clearErrors = () => ({
  type: constants.CLEAR_ERRORS,
})
export const continueSignup = id => ({
  payload: { id },
  type: constants.CONTINUE_SIGNUP,
})
export const downloadPdf = signup => ({
  payload: { signup },
  type: constants.DOWNLOAD_PDF,
})
export const editSignup = id => ({
  payload: { id },
  type: constants.EDIT_SIGNUP,
})
export const endValidation = () => ({
  type: constants.END_VALIDATION,
})
export const endWork = () => ({
  type: constants.END_WORK,
})
export const forgetAllSignups = () => ({
  type: constants.FORGET_ALL_SIGNUPS,
})
export const forgetSignup = reference => ({
  payload: { reference },
  type: constants.FORGET_SIGNUP,
})
export const loadUserSignups = () => ({
  type: constants.LOAD_USER_SIGNUPS,
})
export const rememberSignup = (reference, accessKey) => ({
  payload: { accessKey, reference },
  type: constants.REMEMBER_SIGNUP,
})
export const replaceCurrentSignup = (signup, agree) => ({
  payload: { agree, signup },
  type: constants.REPLACE_CURRENT_SIGNUP,
})
export const revisitingSignup = () => ({
  type: constants.REVISITING_SIGNUP,
})
export const qualifyAddress = (address, searchedAddress) => ({
  payload: {
    address,
    searchedAddress,
  },
  type: constants.QUALIFY_ADDRESS,
})
export const selectClient = (clientId, billingGroupId) => ({
  payload: {
    billingGroupId,
    clientId,
  },
  type: constants.SELECT_CLIENT,
})
export const selectOffer = offerId => ({
  payload: {
    offerId,
  },
  type: constants.SELECT_OFFER,
})
export const selectToken = tokenUuid => ({
  payload: { tokenUuid },
  type: constants.SELECT_TOKEN,
})
export const selectUser = userId => ({
  payload: {
    userId,
  },
  type: constants.SELECT_USER,
})
export const setAbn = abn => ({
  payload: { abn },
  type: constants.SET_ABN,
})
export const setAddress = address => ({
  payload: { address },
  type: constants.SET_ADDRESS,
})
export const setAddressLocId = locId => ({
  payload: { locId },
  type: constants.SET_ADDRESS_LOCID,
})
export const setChallengePhrase = challengePhrase => ({
  payload: { challengePhrase },
  type: constants.SET_CHALLENGE_PHRASE,
})
export const setCompanyName = companyName => ({
  payload: { companyName },
  type: constants.SET_COMPANY_NAME,
})
export const setCompanySize = companySize => ({
  payload: { companySize },
  type: constants.SET_COMPANY_SIZE,
})
export const setContact = contact => ({
  payload: { contact },
  type: constants.SET_CONTACT,
})
export const setCoupon = coupon => ({
  payload: { coupon },
  type: constants.SET_COUPON,
})
export const setCustomerReference = reference => ({
  payload: { reference },
  type: constants.SET_CUSTOMER_REFERENCE,
})
export const setData = (key, value) => ({
  payload: {
    key,
    value,
  },
  type: constants.SET_DATA,
})
export const setDateOfBirth = dateOfBirth => ({
  payload: { dateOfBirth },
  type: constants.SET_DATE_OF_BIRTH,
})
export const setEmail = email => ({
  payload: { email },
  type: constants.SET_EMAIL,
})
export const setEmailConfirm = email => ({
  payload: { email },
  type: constants.SET_EMAIL_CONFIRM,
})
export const setExtraOfferId = extraOfferId => ({
  payload: { extraOfferId },
  type: constants.SET_EXTRA_OFFER_ID,
})
export const setFirstName = firstName => ({
  payload: { firstName },
  type: constants.SET_FIRST_NAME,
})
export const setLastName = lastName => ({
  payload: { lastName },
  type: constants.SET_LAST_NAME,
})
export const setNeedsVoice = needsVoice => ({
  payload: { needsVoice },
  type: constants.SET_NEEDS_VOICE,
})
export const setPartnerApproved = approved => ({
  payload: { approved },
  type: constants.SET_PARTNER_APPROVED,
})
export const setPreferredAppointmentDate = preferredAppointmentDate => ({
  payload: { preferredAppointmentDate },
  type: constants.SET_PREFERRED_APPOINTMENT_DATE,
})
export const setPreferredAppointmentTime = preferredAppointmentTime => ({
  payload: { preferredAppointmentTime },
  type: constants.SET_PREFERRED_APPOINTMENT_TIME,
})
export const setQualification = qualification => ({
  payload: { qualification },
  type: constants.SET_QUALIFICATION,
})
export const setQualificationResults = annotatedResults => ({
  payload: { annotatedResults },
  type: constants.SET_QUALIFICATION_RESULT,
})
export const setServicePassword = servicePassword => ({
  payload: { servicePassword },
  type: constants.SET_SERVICE_PASSWORD,
})
export const setSiteContactFirstName = contactFirstName => ({
  payload: { contactFirstName },
  type: constants.SET_SITE_CONTACT_FIRST_NAME,
})
export const setSiteContactLastName = contactLastName => ({
  payload: { contactLastName },
  type: constants.SET_SITE_CONTACT_LAST_NAME,
})
export const setSiteContactNumber = contactNumber => ({
  payload: { contactNumber },
  type: constants.SET_SITE_CONTACT_NUMBER,
})
export const setUseExistingNumber = useExistingNumber => ({
  payload: { useExistingNumber },
  type: constants.SET_USE_EXISTING_NUMBER,
})
export const setUserPassword = userPassword => ({
  payload: { userPassword },
  type: constants.SET_USER_PASSWORD,
})
export const submit = (sourceId, contactDetails) => ({
  payload: {sourceId, contactDetails},
  type: constants.SUBMIT,
})
export const submitHeardAbout = (heardAbout, signupWithExternals) => ({
  payload: { heardAbout, signupWithExternals },
  type: constants.SUBMIT_HEARD_ABOUT,
})
export const submitMsp = () => ({
  type: constants.SUBMIT_MSP,
})
export const updateFilter = (field, value, cascade = true) => ({
  payload: {
    cascade,
    field,
    value,
  },
  type: constants.UPDATE_FILTER,
})



// WEBPACK FOOTER //
// ./src/redux/modules/signupEdit/actions.js